export default __webpack_public_path__ + "static/blog-3-e4e1c4e0a358f7328d325d0412482d97.jpg";